import { Node } from "@xyflow/react";
import { EdgeBase } from "@xyflow/system";
import { EdgeType } from "~/lib/pipeline/graph/EdgeType";
import { NodeType } from "~/lib/pipeline/graph/NodeType";
import { State, Outcome } from "~/lib/pipeline/Step";

export type Edge = EdgeBase<EdgeData>;
export type EdgeWithConnections = Edge & { sourceNode: Node; targetNode: Node };

export enum EdgeState {
  // Open is when the source node has finished and the target node is ready to run (or already has run).
  Open = "open",
  // Closed is when the source node hasn't yet finished and is blocking the target from running.
  Closed = "closed",
}

export type EdgeData = {
  /**
   * Parent node ID for edge source node.
   */
  sourceParentId?: string;

  /**
   * Parent node ID for edge target node.
   */
  targetParentId?: string;

  state: EdgeState;
};

export function createEdge(
  source: Node<{ state?: State; outcome?: Outcome }>,
  target: Node<{ state?: State; outcome?: Outcome }>,
  type: EdgeType,
): EdgeWithConnections {
  let state: EdgeState;

  // TODO: Handle `allowed_dependency_failure` here.
  // TODO: Handle `wait` steps not tranisitioning to `finished` state.

  if (source.type === NodeType.Root) {
    state = EdgeState.Open;
  } else if (
    (target.type === NodeType.Input ||
      target.type === NodeType.Wait ||
      target.type === NodeType.Block) &&
    source.data.outcome === Outcome.Passed
  ) {
    state = EdgeState.Open;
  } else if (
    target.data.state === State.WaitingForDependencies ||
    (target.data.state === State.Ignored && source.data.outcome !== Outcome.Passed)
  ) {
    state = EdgeState.Closed;
  } else {
    state = EdgeState.Open;
  }

  return {
    id: `${source.id}-${target.id}`,
    source: source.id,
    target: target.id,
    sourceNode: source,
    targetNode: target,
    type,
    data: {
      state,
      sourceParentId: source.parentId,
      targetParentId: target.parentId,
    },
  };
}
